import { Link } from 'react-router-dom'
import { Breadcrumb ,message  } from 'antd';
import copy from "copy-to-clipboard";
import './RefundPolicy.less'

const handleCopy = (value:any) => {
	copy(value);
	message.success('Copy successful!');
}
export default () => (
	<div className="RefundPolicy">
		<div className="page-routers-header">
			<Breadcrumb className="page-header-content">
				<Breadcrumb.Item>
				  <a href="/">Home</a>
				</Breadcrumb.Item>
				<Breadcrumb.Item>Refund Policy</Breadcrumb.Item>
			</Breadcrumb>
		</div>
		<div className="page-footer-container">
			<div className="page-footer-content">
				<div className="page-title">Refund Policy</div>
				<div>
					<div className="content-block">
						<p className="title">Returns</p>
						<p>Our policy lasts 30 days. If 30 days have gone by since your purchase, unfortunately we can’t offer you a refund or exchange.</p>
						<p>To be eligible for a return, your item must be unused and in the same condition that you received it. It must also be in the original packaging.</p>
						<p>Several types of goods are exempt from being returned. Perishable goods such as food, flowers, newspapers or magazines cannot be returned. We also do not accept products that are intimate or sanitary goods, hazardous materials, or flammable liquids or gases.</p>
						<p>Additional non-returnable items:</p>
						<ul className="content">
							<li>Gift cards</li>
							<li>Downloadable software products</li>
							<li>Some health and personal care items</li>
						</ul>
						<p>To complete your return, we require a receipt or proof of purchase.</p>
						<p>There are certain situations where only partial refunds are granted(if applicable):</p>
						<ul className="content">
							<li>Any item not in its original condition, is damaged or missing parts for reasons not due to our error.</li>
							<li>Any item that is returned more than 30 days after delivery.</li>
						</ul>
					</div>
					<div className="content-block">
						<p className="title">Refunds (if applicable)</p>
						<p>Once your return is received and inspected, we will send you an email to notify you that we have received your returned item. We will also notify you of the approval or rejection of your refund.</p>
						<p>If you are approved, then your refund will be processed, and a credit will automatically be applied to your credit card or original method of payment, within a certain amount of days.</p>
					</div>
					<div className="content-block">
						<p className="title">Late or missing refunds (if applicable)</p>
						<p>If you haven’t received a refund yet, first check your bank account again.Then contact your credit card company, it may take some time before your refund is officially posted.</p>
						<p>Next contact your bank. There is often some processing time before a refund is posted.If you’ve done all of this and you still have not received your refund yet, please contact us at <span onClick={() => {handleCopy('support@snailcle.com')}} className="email_text">support@snailcle.com</span></p>
					</div>
					<div className="content-block">
						<p className="title">Exchanges (if applicable)</p>
						<p>We only replace items if they are defective or damaged. If you need to exchange it for the same item, send us an email at <span onClick={() => {handleCopy('support@snailcle.com')}} className="email_text">support@snailcle.com</span>.</p>
						<p>If  the item wasn’t marked as a gift when purchased, or the gift giver had the order shipped to themselves to give to you later, we will send a refund to the gift giver and he will find out about your return.</p>
					</div>
					<div className="content-block">
						<p className="title">Shipping</p>
						<p>To return your product, you should mail your product to: warehouse address</p>
						<p>You will be responsible for paying for your own shipping costs for returning your item. Shipping costs are non-refundable. If you receive a refund, the cost of return shipping will be deducted from your refund.</p>
						<p>Depending on where you live, the time it may take for your exchanged product to reach you, may vary.</p>
						<p>If you are shipping an item back, you should consider using a trackable shipping service or purchasing shipping insurance. We don’t uarantee that we will receive your returned item.</p>
						<p>Items may be subject to a restocking fee of up to 20% of the item’s cost. If your item was delivered via Standard Delivery, In-Room Delivery or White Glove Delivery & Assembly, you will not be responsible for return shipping costs or a restocking fee.</p>
					</div>
				</div>
			</div>
		</div>
	</div>
)